<template>
  <div class="eventRow" :class="classes">
    <span class="eventRow-date">
      <template v-if="isCurrentEvent">now</template>
      <template v-else>{{ event.date | shortTime }}</template>
    </span>
    <span class="eventRow-name">{{ event.name }}</span>
    <span class="eventRow-duration">{{ eventDuration }}</span>
  </div>
</template>

<script>
import dayjs from 'dayjs'

function durationify(minutes) {
  if (minutes > 60) {
    const hours = Math.floor(minutes / 60)
    const newMins = minutes % 60

    return newMins === 0 ? `${hours}h` : `${hours}h ${newMins}m`
  } else {
    return `${minutes}m`
  }
}

export default {
  filters: {
    shortTime: string => dayjs(string).format('HH:mm')
  },
  props: {
    event: { type: Object, required: true },
    isCurrentEvent: { type: Boolean, default: false }
  },
  data() {
    return {
      eventDuration: ''
    }
  },
  computed: {
    classes() {
      return {
        'eventRow-isHighlighted': this.event.injectedEvent
      }
    }
  },
  mounted() {
    this.$timer.addListener(this, () => this.tick())
    this.tick()
  },
  destroyed() {
    this.$timer.removeListener(this)
  },
  methods: {
    tick() {
      const now = dayjs()
      const end = dayjs(this.event.date).add(this.event.duration, 'minute')

      if (this.isCurrentEvent) {
        const diff = Math.ceil(end.diff(now, 'm', true))

        this.eventDuration = durationify(diff) + ' left'
      } else {
        this.eventDuration = durationify(this.event.duration)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.eventRow {
  display: flex;
  font-size: $size-body;
  text-align: left;
  background-color: $red;
  color: $white;
  padding: 0.3em;
  margin: 0 -0.3em;
  border-radius: 4px;
}

.eventRow-date {
  font-variant-numeric: tabular-nums;
  text-decoration: underline;
  opacity: 0.8;
}

.eventRow-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.4em;
}

.eventRow-duration {
  opacity: 0.8;
}

.eventRow-isHighlighted {
  background-color: $green;
}
</style>
